const ToggleFilter = (function () {
    'use strict'

    let filter;

    const init = () => {
        filter = document.querySelector('[data-hook=filterpane]');
    }

    const toggle = (btn) => {
        if (filter.getAttribute('data-is-open') === null) {
            filter.setAttribute('data-is-open', '');
            btn.setAttribute('data-is-open', '');
        } else {
            filter.removeAttribute('data-is-open');
            btn.removeAttribute('data-is-open');
        }
    }

    return {
        init: init,
        toggle: toggle,
    }
})();
